var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.certDetails)?_c('json-formatter',{attrs:{"data":_vm.certDetails,"path":"res"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }